document.addEventListener('DOMContentLoaded', function () {
  var values = document.querySelectorAll('[data-stat-value]');
  if (!values.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        var duration = 1400;
        var start = null;

        function step(timestamp) {
          if (!start) start = timestamp;
          var progress = Math.min((timestamp - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(eased * target);
          el.textContent = current + '%';

          if (progress < 1) {
            window.requestAnimationFrame(step);
          }
        }

        window.requestAnimationFrame(step);
        observer.unobserve(el);
      });
    },
    { threshold: 0.4 }
  );

  values.forEach(function (el) {
    observer.observe(el);
  });

  // Glow trail: spawns small fading dots along the cursor/finger's
  // path as it moves across a card, creating a comet-style trail
  // rather than one blob that follows with a lag.
  document.querySelectorAll('.custom-stats__card').forEach(function (card) {
    if (typeof gsap === 'undefined') return;

    var lastSpawn = 0;
    var minInterval = 35; // ms between dots, keeps the trail smooth without flooding the DOM

    function spawnDot(x, y) {
      var now = Date.now();
      if (now - lastSpawn < minInterval) return;
      lastSpawn = now;

      var dot = document.createElement('span');
      dot.className = 'custom-stats__trail-dot';
      dot.style.left = x + 'px';
      dot.style.top = y + 'px';
      card.appendChild(dot);

      gsap.to(dot, {
        opacity: 0,
        scale: 0.2,
        duration: 0.7,
        ease: 'power1.out',
        onComplete: function () {
          dot.remove();
        }
      });
    }

    // Touch
    card.addEventListener(
      'touchstart',
      function (e) {
        var rect = card.getBoundingClientRect();
        var touch = e.touches[0];
        spawnDot(touch.clientX - rect.left, touch.clientY - rect.top);
      },
      { passive: true }
    );

    card.addEventListener(
      'touchmove',
      function (e) {
        var rect = card.getBoundingClientRect();
        var touch = e.touches[0];
        spawnDot(touch.clientX - rect.left, touch.clientY - rect.top);
      },
      { passive: true }
    );

    // Mouse
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      spawnDot(e.clientX - rect.left, e.clientY - rect.top);
    });
  });
});